{
    const menu = document.querySelector('.sidemenu');
    const list = document.querySelectorAll('.sidemenu__item');
    const output = document.querySelector('.sidemenu__output');
    const collapses = document.querySelectorAll('.collapse');
    const buttonShowAll = document.querySelectorAll('.js-show-all');

    const resetActiveClass = (list) => list.forEach(item => item.classList.remove('is-active'));

    if (list && collapses && output) {
        if (!location.hash) {
            // activate first item & collapse
            const firstItem = list[0];
            const firstCollapse = collapses[0];

            firstItem.classList.add('is-active');
            firstCollapse.classList.add('is-active');
            output.innerHTML = firstItem.innerHTML;
        } else {
            // activate item & collapse by hash
            const hash = location.hash;
            const hashTxt = document.querySelector('[data-collapse-href="' + hash + '"]');
            const hashItem = hashTxt.parentNode;
            const hashCollapse = document.querySelector(hashItem.dataset.collapseId);

            hashItem.classList.add('is-active');
            hashCollapse.classList.add('is-active');
            output.innerHTML = hashItem.innerHTML;

            // remove hash from url
            history.pushState("", document.title, window.location.pathname);
        }
    }

    menu && menu.addEventListener('click', (e) => {
        const txt = e.target.closest('.sidemenu__txt');
        const item = e.target.closest('.sidemenu__item');

        if (txt && item) {
            if (!item.matches('.is-active')) {
                const id = item.dataset.collapseId;
                const collapse = document.querySelector(id);

                resetActiveClass(list);
                resetActiveClass(collapses);
                item.classList.add('is-active');
                collapse.classList.add('is-active');
            }

            output.innerHTML = txt.outerHTML;
        }

        menu.classList.toggle('sidemenu_open');
    });

    collapses.forEach(collapse => {
        const parent = document.getElementById(collapse.id);
        const items  = Array.from(parent.children);

        items.forEach((item, i) => {
            if (!i && menu) item.classList.add('is-active');

            item.addEventListener('click', () => {
                if (item.classList.contains('js-show-all')) return false;
                resetActiveClass(items);
                item.classList.toggle('is-active');
            });
        });
    });

    buttonShowAll.forEach((button) => {
        button.addEventListener('click', (evt) => {
            const parent = evt.target.parentElement;
            evt.target.textContent = evt.target.textContent === evt.target.dataset.more ? evt.target.dataset.less : evt.target.dataset.more ;
            parent.classList.toggle('show-all');
        })
    });
}

{
    const resetButton = document.querySelector('.knowledge-header__clear');
    const searchInput = document.querySelector('.knowledge-header__field');

    // Clearing text from the search field
    resetButton.addEventListener('click', (evt)=> {
        searchInput.value = '';
        resetButton.classList.remove('is-visible');
        searchInput.focus();
    });

    searchInput.addEventListener('input', (evt) => {
        if(evt.target.value.length > 0) {
            resetButton.classList.add('is-visible');
        } else {
            resetButton.classList.remove('is-visible');
        }
    })
}
